import { render, staticRenderFns } from "./AppraisalReview.vue?vue&type=template&id=0573c062&scoped=true&"
import script from "./AppraisalReview.vue?vue&type=script&lang=js&"
export * from "./AppraisalReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0573c062",
  null
  
)

export default component.exports